import { SettlementsApiBase } from './paymentApi';

class SettlementApi extends SettlementsApiBase {
}

export default new SettlementApi();
